import React, { FC, useState } from "react";
import MonographicAdd from "./MonographicAdd";
import MonographicsListComponent from "./MonographicListComponent";
import { BlackButton } from "../../../styles/styledcomponets";
import MonographicDetails from "./MonographicDetails";

enum States {
  LISTING = 0,
  ADDING = 1,
  EDITING = 2
}

const MonographicsCMSLayout: FC = () => {
  const [state, setState] = useState<States>(States.LISTING);
  const [workID, setWorkID] = useState<string | undefined>(undefined);

  const workSaved = () => {
    setState(States.LISTING);
  };

  const selectWorkToEdit = (id: string, state: States): void => {
    setWorkID(id);
    setState(state);
  };

  return (
    <React.Fragment>
      {state === States.LISTING && (
        <>
          <BlackButton onClick={() => setState(States.ADDING)}>
            Add new work
          </BlackButton>
          <MonographicsListComponent workIDHandler={selectWorkToEdit} />
          <BlackButton onClick={() => setState(States.ADDING)}>
            Add new work
          </BlackButton>
        </>
      )}

      {[States.ADDING, States.EDITING].includes(state) && (
        <BlackButton onClick={() => setState(States.LISTING)}>
          Go back to works list
        </BlackButton>
      )}

      {state === States.ADDING && <MonographicAdd workSaved={workSaved} />}
      {state === States.EDITING && workID && <MonographicDetails id={workID} />}

      {[States.ADDING, States.EDITING].includes(state) && (
        <BlackButton onClick={() => setState(States.LISTING)}>
          Go back to works list
        </BlackButton>
      )}
    </React.Fragment>
  );
};

export default MonographicsCMSLayout;
